import React from 'react';
import { ModalButtonProps } from '../../types/modal.types';

const ModalButton: React.FC<ModalButtonProps> = ({
                                                   variant = 'default',
                                                   type = 'regular',
                                                   children,
                                                   onClick,
                                                   disabled = false
                                                 }) => {
  const baseClass = type === 'round' ? 'modal-button-round' : 'modal-button';
  const variantClass = variant !== 'default' ? `${baseClass}--${variant}` : '';
  const className = `${baseClass} ${variantClass}`.trim();

  const buttonType = type === 'submit' ? 'submit' : 'button';

  return (
    <button
      type={buttonType}
      className={className}
      onClick={onClick}
      disabled={disabled}
    >
      <span className="modal-button__inner">
        {children}
      </span>
    </button>
  );
};

export default ModalButton;